import { asyncRouterMap, allRouters } from '@/router/router.config'
import { getMenuInfo } from '@/api/login'
// import Vue from 'vue'
/**
 * 过滤账户是否拥有某一个权限，并将菜单从加载列表移除
 *
 * @param permission
 * @param route
 * @returns {boolean}
 */
// function hasPermission(permission, route) {
//   if (route.meta && route.meta.permission) {
//     let flag = false
//     for (let i = 0, len = permission.length; i < len; i++) {
//       flag = route.meta.permission.includes(permission[i])
//       if (flag) {
//         return true
//       }
//     }
//     return false
//   }
//   return true
// }

/**
 * 单账户多角色时，使用该方法可过滤角色不存在的菜单
 *
 * @param roles
 * @param route
 * @returns {*}
 */
// eslint-disable-next-line
function hasRole(roles, route) {
  if (route.meta && route.meta.roles) {
    return route.meta.permission.includes(roles)
  } else {
    return true
  }
}
const permission = {
  state: {
    menuCode: [], // 菜单编码数组
    btnCode: [], // 按钮权限数组
    routes: [],
    routers: allRouters,
    addRouters: asyncRouterMap,
    isUpdata: false,
    routeList: []
  },
  mutations: {
    setMenu (state, list) {
      state.menuCode = list
    },
    setBtn (state, list) {
      state.btnCode = list
    },
    SET_STOCK (state, list) {
      state.routeList = list
    },
    // SET_ROUTERS: (state, routers) => {
    //   state.addRouters = asyncRouterMap,
    //   state.routers = constantRouterMap.concat(routers)
    // },
    SET_UPDATA: (state) => {
      state.isUpdata = !state.isUpdata
    }
  },
  actions: {
    getAgentMenuInfo () {
      return getMenuInfo({ subsystem: 'app_1585' }).then(res => {
        if (res.code === '0' && res.data && res.data.menuList) {
          const menuList = res.data.menuList
          window.sessionStorage.setItem('appNavs', JSON.stringify(menuList))
        }
      })
    }
  }
}

export default permission
